<div *svgFrontendsLet="formControl.statusChanges | async as status" class="mac-wrapper">
	<svg-frontends-loading *ngIf="status === FORM_STATUS.PENDING" [isSmall]="true" [withBackdrop]="true"></svg-frontends-loading>

	<div class="clr-form-control mac-form-control">
		<label *ngIf="label" [for]="id" class="clr-control-label">
			<svg-frontends-string-or-template-ref [value]="label"></svg-frontends-string-or-template-ref>
			<svg-frontends-required-marker *ngIf="formControl | isFormControlRequired"></svg-frontends-required-marker>
		</label>

		<div [ngClass]="{ 'clr-error': formControl.invalid && formControl.touched }" class="clr-control-container">
			<div class="clr-textarea-wrapper">
				<textarea
					[formControl]="formControl"
					[id]="id"
					[svgFrontendsDisableControl]="disableControl"
					[name]="id"
					[ngStyle]="{ 'background-color': backgroundColor }"
					[placeholder]="placeholder"
					class="clr-textarea mac-input"
				></textarea>
				<cds-icon class="clr-validate-icon" shape="exclamation-circle"></cds-icon>
			</div>

			<div class="clr-subtext-wrapper mac-subtext-wrapper">
				<span *ngIf="helperText && !(formControl.invalid && formControl.touched)" class="clr-subtext">
					<svg-frontends-string-or-template-ref [value]="helperText"></svg-frontends-string-or-template-ref>
				</span>
				<span *ngIf="formControl.invalid && formControl.touched" class="clr-subtext">
					{{ formControl.errors | firstControlError | controlErrorMessage }}
				</span>
			</div>
		</div>
	</div>
</div>
